import { Component } from '@angular/core';
import { InfoBoxMapService } from 'src/services/maps/features/InfoBox-Map.service';

@Component({
  selector: 'tool-street-info-box',
  templateUrl: './tool-street-info-box.component.html',
  styleUrls: ['./tool-street-info-box.component.css']
})
export class ToolStreetInfoBoxComponent {

  constructor(public toolInfoBoxService: InfoBoxMapService) {}

  onClickIntersect(){
    this.toolInfoBoxService.isInfoBoxActive = !this.toolInfoBoxService.isInfoBoxActive;
    if (!this.toolInfoBoxService.isInfoBoxActive) {
      this.toolInfoBoxService.infoBoxDeactivated.next();
    }
  }

}
